import Vue from 'vue/dist/vue.esm'

Vue.component(
  "sofia-wrapper-vue",
  () => import(/* webpackChunkName: "[request]" */ "components/sofia/Wrapper")
)
